export const SPRUCE_PHOTOS_STEP = "spruce-photos"
export const SPRUCE_PHOTOS_DESCRIPTION = "Motorcycle Photos"
export const PHOTOS = "photos"
